import { motion } from "framer-motion";
import { Apple, Play } from "lucide-react";
import { triggerDownload } from "@/lib/leadzi";

export const DownloadButton = ({
  className = "",
  testId,
  label = "Télécharger Leadzi CHR",
  variant = "solid",
}) => {
  const base =
    "group relative inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-bold tracking-tight transition-all duration-300 will-change-transform";
  const styles =
    variant === "solid"
      ? "bg-brand text-white hover:bg-brand-hover shadow-[0_10px_30px_-8px_rgba(232,80,46,0.7)] hover:shadow-[0_14px_40px_-6px_rgba(232,80,46,0.8)] hover:-translate-y-0.5"
      : variant === "light"
        ? "bg-white text-ink hover:bg-white/90 shadow-lg hover:-translate-y-0.5"
        : "bg-ink text-white hover:bg-ink/90 hover:-translate-y-0.5";
  return (
    <button data-testid={testId} onClick={triggerDownload} className={`${base} ${styles} ${className}`}>
      {label}
      <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
    </button>
  );
};

const StoreBtn = ({ icon: Icon, top, bottom, testId }) => (
  <motion.button
    data-testid={testId}
    onClick={triggerDownload}
    whileHover={{ y: -3 }}
    whileTap={{ scale: 0.97 }}
    className="inline-flex items-center gap-3 rounded-2xl border border-white/15 bg-white/5 px-5 py-2.5 text-left text-white backdrop-blur transition-colors hover:border-brand/60 hover:bg-white/10"
  >
    <Icon className="h-7 w-7 shrink-0" />
    <span className="leading-tight">
      <span className="block text-[10px] uppercase tracking-widest text-white/50">{top}</span>
      <span className="block text-sm font-bold">{bottom}</span>
    </span>
  </motion.button>
);

export const StoreButtons = ({ className = "", light = false }) => {
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className} ${light ? "" : "[&_button]:border-black/10 [&_button]:bg-ink [&_button]:text-white"}`}>
      <StoreBtn icon={Apple} top="Télécharger sur" bottom="App Store" testId="app-store-download-button" />
      <StoreBtn icon={Play} top="Disponible sur" bottom="Google Play" testId="google-play-download-button" />
    </div>
  );
};
